<template>
  <div>
    <form class="class_add_con w622 col_2_1" data-vv-scope="form" style="min-height: auto;">
      <TagPicker :params="inputs" @tagsChanged="getData" @userTagsUpdated="userTagsUpdated"></TagPicker>
      <div class="add_bt_foot">
        <input name="" class="hui_color" type="button" value="返回" @click="emit('closed')" />
      </div>
    </form>
  </div>
</template>

<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import TagPicker from '@/components/byl/tagPicker/index.vue'
    export default {
      components: { TagPicker },
      props: ['params'],
      mounted () {
      },
      data () {
        return {
          obj: {},
          form: [],
          inputs: []
        }
      },
      watch: {
        // inputs: {
        //   handler (newVal, oldVal) {
        //     this.inputs = $.extend(true, [], newVal); // 深复制对象
        //   },
        //   deep: true
        // },
        params: {
          handler (newVal, oldVal) {
            // this.inputs = newVal
            this.inputs = $.extend(true, [], newVal); // 深复制对象
          },
          deep: true
        }
      },
      methods: {
        emit (msg, p) {
          this.$emit(msg, p)
        },
        getData (val) {
          this.form = val
          this.emit('saved', this.form)
        },
        userTagsUpdated (val) {
          this.$emit('userTagsUpdated', val)
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/byl/org/structure/tag.vue